import { GraphicSelectModel } from './GraphicSelectModel';

export class GraphicSelectNumModel extends GraphicSelectModel {}
